import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getDisplayNameHOC } from 'app/utils';
import watchlistModule from 'app/store/watchlist';

const { requestAddEventToList, requestRemoveEventFromList } = watchlistModule.actions;
const mapDispatchToProps = {
  addToWatchlist: requestAddEventToList,
  removeFromWatchlist: requestRemoveEventFromList
};

const mapStateToProps = ({ watchlist: { watchlist, events, errorId } }) => ({
  events,
  watchlist: watchlist.events,
  watchlistErrorId: errorId
});

const WithEventsWatchlistBtn = WrappedComponent => {
  const displayName = `WithEventsWatchlistBtn(${getDisplayNameHOC(WrappedComponent)})`;
  const propTypes = {
    events: PropTypes.arrayOf(PropTypes.object).isRequired,
    watchlist: PropTypes.arrayOf(PropTypes.object).isRequired,
    watchlistErrorId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    addToWatchlist: PropTypes.func.isRequired,
    removeFromWatchlist: PropTypes.func.isRequired
  };
  const defaultProps = {
    watchlistErrorId: null
  };

  const Component = ({
    events,
    watchlist,
    watchlistErrorId,
    addToWatchlist,
    removeFromWatchlist,
    ...props
  }) => {
    const isItemInWatchlist = (items, id) => items.some(item => item.eventId === id);

    return (
      <WrappedComponent
        {...props}
        data={events}
        watchlist={watchlist}
        watchlistErrorId={watchlistErrorId}
        addToWatchlist={addToWatchlist}
        removeFromWatchlist={removeFromWatchlist}
        isItemInWatchlist={isItemInWatchlist}
      />
    );
  };

  Component.displayName = displayName;
  Component.propTypes = propTypes;
  Component.defaultProps = defaultProps;

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Component);
};

export default WithEventsWatchlistBtn;
